import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { inventoryAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { fmtMoney } from '../../utils/currency';
const fmt = fmtMoney;
export default function InventoryList() {
  const navigate = useNavigate(); const [items, setItems] = useState([]); const [loading, setLoading] = useState(true); const [valuation, setValuation] = useState(null);
  useEffect(() => { inventoryAPI.list({}).then(setItems).catch(e=>toast.error(e.message)).finally(()=>setLoading(false)); inventoryAPI.valuation().then(setValuation).catch(console.error); }, []);
  return (
    <div>
      <div className="toolbar"><h2>Inventory</h2>
        <div className="toolbar-right">
          <button className="btn btn-outline" onClick={()=>navigate('/inventory/adjust')}>Adjust Stock</button>
          <button className="btn btn-primary" onClick={()=>navigate('/products/new')}>+ New Item</button>
        </div>
      </div>
      {valuation && <div className="stats-grid" style={{marginBottom:16}}>
        <div className="stat-card primary"><div className="stat-label">Total Inventory Value</div><div className="stat-value">{fmt(valuation.total_value)}</div></div>
        <div className="stat-card"><div className="stat-label">Total Items</div><div className="stat-value">{items.length}</div></div>
        <div className="stat-card warning"><div className="stat-label">Low Stock Items</div><div className="stat-value">{items.filter(i=>i.reorder_point>0&&i.quantity_on_hand<=i.reorder_point).length}</div></div>
      </div>}
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card"><div className="card-body" style={{padding:0}}>
          <table><thead><tr><th>SKU</th><th>Name</th><th className="text-right">On Hand</th><th className="text-right">Committed</th><th className="text-right">Available</th><th className="text-right">Avg Cost</th><th className="text-right">Value</th><th>Status</th></tr></thead>
            <tbody>{items.map(p=>{const low=p.reorder_point>0&&p.quantity_on_hand<=p.reorder_point;return (<tr key={p.id}>
              <td className="font-mono">{p.sku}</td><td>{p.name}</td>
              <td className="text-right">{p.quantity_on_hand}</td><td className="text-right">{p.quantity_committed||0}</td><td className="text-right">{p.quantity_available||p.quantity_on_hand}</td>
              <td className="amount">{fmt(p.average_cost)}</td>
              <td className="amount">{fmt((p.quantity_on_hand||0)*(p.average_cost||0))}</td>
              <td>{low?<span className="badge badge-overdue">Low Stock</span>:<span className="badge badge-posted">OK</span>}</td>
            </tr>);})}
            {items.length===0 && <tr><td colSpan={8} className="text-center text-muted" style={{padding:30}}>No inventory items. Mark products as "Inventory Tracked" to see them here.</td></tr>}
          </tbody></table>
        </div></div>
      )}
    </div>
  );
}
